import { PromptDataProfileDtoToEntity } from "src/app/features/PromptDataProfile/services/mappers/PromptDataProfileDtoToEntity";
import type { PromptDataProfileDto } from "src/app/features/PromptDataProfile/types/PromptDataProfileDto";
import type { PromptDataProfileEntity } from "src/app/features/PromptDataProfile/types/PromptDataProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const PromptDataProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<PromptDataProfileDto>>,
): ResourcePageEntity<PromptDataProfileEntity> => {
    return {
        list: input.list ? input.list.map(PromptDataProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
